import * as React from 'react'
import { useCallback } from 'react'

import { ClosingAgreementRequirementsModel } from '@user/store/closingRequirements/typings'
import type { UseData } from './useData'

export function useHandlers(
  data: UseData,
  onSelected: (model: ClosingAgreementRequirementsModel) => void,
) {
  const { requirement, setRequirement, setDisabled, setDisableAutoClose } = data

  const onCheckedUnChecked = useCallback(
    (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      const req =
        _event?.currentTarget.name === 'requireAgreement' && checked == false
          ? {
              ...requirement,
              requireAgreement: false,
              requireCustomerSignature: false,
              autoCloseWinLeads: false,
              autoCloseWinOpportunities: false,
            }
          : {
              ...requirement,
              [_event?.currentTarget.name]: checked,
            }

      if (_event?.currentTarget.name === 'requireCustomerSignature') {
        setDisableAutoClose(!checked)
        if (checked == false) {
          req.autoCloseWinLeads = false
          req.autoCloseWinOpportunities = false
        }
      } else {
        setDisableAutoClose(!req.requireCustomerSignature)
      }

      setDisabled(!req.requireAgreement)
      setRequirement(req)
      onSelected(req)
    },
    [requirement, setDisabled, setRequirement, onSelected, setDisableAutoClose],
  )

  return { onCheckedUnChecked }
}
